/* global Pendo */
import { useEffect, useRef } from 'react';

const usePendo = () => {
    const ref = useRef<Pendo>(window.pendo);

    useEffect(() => {
        ref.current = window.pendo;
    }, [window.pendo]);

    return { pendo: ref.current };
};

export default usePendo;
